module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/16RXgdb/tc-custom/9781552548677.jpg?1728851674295",
      "alt": "This image is the cover for the book Sicilian's Marriage Arrangement"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Sicilian's Marriage Arrangement\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A woman discovers the husband she loves was forced by her family to marry her in this sexy romance by a "), _c('i', [_vm._v("USA Today")]), _vm._v("–bestselling author.")]), _c('br'), _c('br'), _vm._v("Hope Bishop is stunned when darkly sexy Sicilian tycoon Luciano di Valerio proposes marriage. Brought up by her wealthy but distant grandfather, she is used to fading into the background and being ignored."), _c('br'), _c('br'), _vm._v("But Luciano’s sensual lovemaking makes her feel vibrantly alive. Hope falls in love with her husband and is blissfully happy—until she discovers that Luciano ruthlessly married her—for convenience!"), _c('br'), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Lucy  Monroe\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("USA Today Bestseller Lucy Monroe finds inspiration for her stories everywhere as she is an avid people-watcher. She has published more than fifty books in several subgenres of romance and when she's not writing, Lucy likes to read.  She's an unashamed book geek, but loves movies and the theatre too. She adores her family and truly enjoys hearing from her readers! Visit her website at: http://lucymonroe.com")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin Enterprises\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0